// extracted by mini-css-extract-plugin
export default {"preNotificationContainer":"B9YA8","text":"_1yd7z","fill":"_377be","x":"JqsuX","cursorPointer":"_1lGfB","cursorAuto":"_1A-9o"};